import React from 'react';
import { Link } from 'react-router-dom';
import { FaHome } from 'react-icons/fa';
import { MdOutlineKitchen } from 'react-icons/md';
import { GiWoodenChair } from 'react-icons/gi';
import '../styles/Estimator.css';

const cards = [
  {
    id: 'full-home',
    title: 'Full Home',
    desc: 'Get an approximate costing for your full home interiors.',
    to: '/estimator/full-home',
    img: 'https://rdsoftware.in/wp-content/uploads/2025/08/full-home-estimate.jpg',
    icon: <FaHome />,
    meta: ['8–12 weeks', 'End-to-End']
  },
  {
    id: 'kitchen',
    title: 'Kitchen',
    desc: 'Get an approximate costing for your kitchen interior.',
    to: '/estimator/kitchen',
    img: 'https://rdsoftware.in/wp-content/uploads/2025/08/kitchen-estimate.jpg',
    icon: <MdOutlineKitchen />,
    meta: ['4–6 weeks', 'Modular']
  },
  {
    id: 'wardrobe',
    title: 'Wardrobe',
    desc: 'Get an approximate costing for your wardrobe.',
    to: '/estimator/wardrobe',
    img: 'https://rdsoftware.in/wp-content/uploads/2025/08/wardrobe-estimate.jpg',
    icon: <GiWoodenChair />,
    meta: ['2–3 weeks', 'Custom']
  },
];

const Estimator = () => {
  return (
    <section className="estimator-section">
      <div className="container">
        <header className="estimator-header">
          <h1 className="section-title">Estimators</h1>
          <p className="section-subtitle">Choose a category to quickly estimate your project cost—light-touch Vastu and zodiac tips available.</p>
        </header>

        <div className="estimator-grid">
          {cards.map(card => (
            <article key={card.id} className="estimator-card" aria-label={`${card.title} estimator`}>
              <div className="card-media">
                <img src={card.img} alt={card.title} loading="lazy" />
                <div className="media-overlay" />
                <div className="icon-badge" aria-hidden="true">{card.icon}</div>
              </div>
              <div className="card-body">
                <h3 className="card-title">{card.title}</h3>
                <p className="card-desc">{card.desc}</p>
                <div className="card-meta" role="list" aria-label="Highlights">
                  {card.meta?.map((m, i) => (
                    <span key={i} className="chip" role="listitem">{m}</span>
                  ))}
                </div>
                <Link className="card-cta" to={card.to}>
                  Calculate
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Estimator;
